import { configureStore } from '@reduxjs/toolkit';
import productsReducer from 'store/slices/productsSlice';
import categoriesReducer from 'store/slices/categoriesSlice';
import subcategoriesReducer from 'store/slices/subcategoriesSlice';

export const store = configureStore({
  reducer: {
    products: productsReducer,
    categories: categoriesReducer,
    subcategories: subcategoriesReducer,
  }
});
